import React from 'react';
import sadio from '../assets/illustration-webp/sadio.webp';
import bakugo from '../assets/illustration/bakugo-pfp.jpg';
import natha from '../assets/illustration/natha.jpg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXTwitter, faInstagram, faTiktok, faYoutube, faTwitch } from "@fortawesome/free-brands-svg-icons";

const ContentCreator = () => {
  return (
    <section className="w-full max-md:py-16 px-4 md:px-8">
      <div className="w-full max-w-[2250px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          <div 
            className="card bg-neutral-900 rounded-lg shadow-md hover:shadow-lg p-4 md:p-6 flex flex-col"
            data-aos="fade-right" 
            data-aos-offset="100"
          >
            <img 
              src={sadio} 
              alt="Sadio" 
              className="w-full h-48 object-cover object-[center_25%] rounded-md mb-4" 
            />
            <h3 className="text-xl font-bold text-[#be185d] mb-2 text-center">Sadio</h3>
            <p className="text-gray-100 text-left text-sm md:text-base mb-auto">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Quibusdam non cumque at provident magni, 
              dolorum pariatur ratione doloremque officia? Explicabo, tempora. Officiis vel tempora nemo, 
              maiores reiciendis repellendus possimus dolores.
            </p>
            <ul className='mt-4 md:mt-6 flex justify-center space-x-4'>
              <li>
                <a href="https://x.com/SADCORP_" target='blank' className="text-gray-100 hover:text-[#d32f2f] transition-colors duration-300">
                  <FontAwesomeIcon icon={faXTwitter} className="text-2xl"/>
                </a>
              </li>
              <li>
                <a href="https://www.instagram.com/bmsjoel/" target='blank' className="text-gray-100 hover:text-[#d32f2f] transition-colors duration-300">
                  <FontAwesomeIcon icon={faInstagram} className="text-2xl"/>
                </a>
              </li>
              <li>
                <a href="https://www.twitch.tv/sadio" target='blank' className="text-gray-100 hover:text-[#d32f2f] transition-colors duration-300">
                  <FontAwesomeIcon icon={faTwitch} className="text-2xl"/>
                </a>
              </li>
            </ul>
          </div>

          <div 
            className="card bg-neutral-900 rounded-lg shadow-md hover:shadow-lg p-4 md:p-6 flex flex-col"
            data-aos="fade-up" 
            data-aos-offset="100"
          >
            <img 
              src={bakugo} 
              alt="Bakugo" 
              className="w-full h-48 object-cover rounded-md mb-4" 
            />
            <h3 className="text-xl font-bold text-[#be185d] mb-2 text-center">Bakugo</h3>
            <p className="text-gray-100 text-left text-sm md:text-base mb-auto">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam, impedit quisquam ullam 
              incidunt cupiditate dolorum, asperiores delectus similique nulla, hic natus. Sapiente deleniti 
              autem nostrum omnis itaque inventore dolore officia.
            </p>
            <ul className='mt-4 md:mt-6 flex justify-center space-x-4'>
              <li>
                <a href="https://x.com/BakugoXIX" target='blank' className="text-gray-100 hover:text-[#d32f2f] transition-colors duration-300">
                  <FontAwesomeIcon icon={faXTwitter} className="text-2xl"/>
                </a>
              </li>
              <li>
                <a href="https://www.instagram.com/bmsjoel/" target='blank' className="text-gray-100 hover:text-[#d32f2f] transition-colors duration-300">
                  <FontAwesomeIcon icon={faInstagram} className="text-2xl"/>
                </a>
              </li>
              <li>
                <a href="https://www.twitch.tv/bakugoxix" target='blank' className="text-gray-100 hover:text-[#d32f2f] transition-colors duration-300">
                  <FontAwesomeIcon icon={faTwitch} className="text-2xl"/>
                </a>
              </li>
            </ul>
          </div>

          <div 
            className="card bg-neutral-900 rounded-lg shadow-md hover:shadow-lg p-4 md:p-6 flex flex-col"
            data-aos="fade-left" 
            data-aos-offset="100"
          >
            <img 
              src={natha}
              alt="Natha" 
              className="w-full h-48 object-cover object-[center_20%] rounded-md mb-4" 
            />
            <h3 className="text-xl font-bold text-[#be185d] mb-2 text-center">Natha</h3>
            <p className="text-gray-100 text-left text-sm md:text-base mb-auto">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam molestiae modi illo sequi cumque, 
              officia possimus architecto libero exercitationem doloremque! Ipsum dolores aliquid voluptates minima 
              facere incidunt harum dolorum at.
            </p>
            <ul className='mt-4 md:mt-6 flex justify-center space-x-4'>
              <li>
                <a href="https://x.com/ink_playa" target='blank' className="text-gray-100 hover:text-[#d32f2f] transition-colors duration-300">
                  <FontAwesomeIcon icon={faXTwitter} className="text-2xl"/>
                </a>
              </li>
              <li>
                <a href="https://www.instagram.com/bmsjoel/" target='blank' className="text-gray-100 hover:text-[#d32f2f] transition-colors duration-300">
                  <FontAwesomeIcon icon={faInstagram} className="text-2xl"/>
                </a>
              </li>
              <li>
                <a href="https://www.twitch.tv/bms_natha" target='blank' className="text-gray-100 hover:text-[#d32f2f] transition-colors duration-300">
                  <FontAwesomeIcon icon={faTwitch} className="text-2xl"/>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContentCreator;